import Reveal from '../common/Reveal';
import RotatingWord from '../common/RotatingWord';
import LogoMarquee from '../common/LogoMarquee';
import BreathingBlocks from '../Hero/BreathingBlocks';
import { useWalletModal } from '../../context/WalletModalContext';
import './EcosystemSection.css';

const ROTATING_WORDS = ['Transactions', 'Wallets', 'NFTs', 'Assets', 'RWAs', 'DAOs'];

export default function EcosystemSection() {
  const { open: openWalletModal } = useWalletModal();

  return (
    <section id="ecosystem" className="ecosystem">
      <BreathingBlocks className="ecosystem__blocks" />
      <div className="container ecosystem__inner">
        <Reveal as="up">
          <h2 className="ecosystem__title">
            Privacy for your <RotatingWord words={ROTATING_WORDS} />
          </h2>
        </Reveal>

        <Reveal as="up" delay={0.15} className="ecosystem__marquee-wrap">
          <LogoMarquee />
        </Reveal>

        <Reveal as="up" delay={0.25}>
          <button type="button" className="btn btn--ghost ecosystem__cta" onClick={openWalletModal}>
            Cross Transfer
          </button>
        </Reveal>
      </div>
    </section>
  );
}